export default function scriptsSingleBlog(){

    const  swiperBlog = new Swiper('.swiper-blog',{
        slidesPerView: 1.2,
        spaceBetween: 16,
        breakpoints:{
          540:{
            slidesPerView: 2,
           
          },
          1024:{
            slidesPerView: 3,
    
              
          },
          1200:{
            slidesPerView: 4,
            spaceBetween: 32,
        
          
          }
        },
        // pagination: {
        //   el: ".swiper-pagination",
        //   clickable: true
  
        // },
        navigation: {
          nextEl: ".custom-next",
          prevEl: ".custom-prev",
        },
        
      });
}